import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr'; // For auth after login toast

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';

import { coreConfig } from 'app/app-config';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from "@angular/forms";
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { DashboardModule } from './main/dashboard/dashboard.module';
import { EvaluacionDesempenoServices} from './main/dashboard/etapa2/evaluacion-desempeno/evaluacion-desempeno.service';
import { VisualizarEvaluadosServices} from './main/dashboard/etapa2/evaluacion-desempeno/visualizar-evaluados/visualizar-evaluados.service';
import { ConfigGeneralServices} from './main/dashboard/etapa1/configuracion/configgeneral.service';
import { DatePipe } from '@angular/common';

const appRoutes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: '',
    redirectTo: '/evaluadores',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/pages/miscellaneous/error' //Error 404 - Page not found
  }
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled', // Add options right here
      relativeLinkResolution: 'legacy'
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    // App modules
    LayoutModule,
    ContentHeaderModule,
    DashboardModule,
    AmplifyUIAngularModule
  ],
  providers:[EvaluacionDesempenoServices,ConfigGeneralServices,VisualizarEvaluadosServices,DatePipe],

  bootstrap: [AppComponent]
})
export class AppModule {}
